<template>
  <div class="test-upload">
    <div>
      <h2>员工资料库</h2>
      <ul>
        <li @click="handleUpload(1)">清单数据-上传云文件</li>
        <li @click="handleUpload(2)">清单数据-上传本地文件</li>
        <li @click="handleUpload(3)">清单数据-上传数据文件</li>
        <li @click="handleUpload(4)">组价数据-上传云文件</li>
        <li @click="handleUpload(5)">组价数据-上传本地文件</li>
        <li @click="handleUpload(6)">组价数据-上传数据文件</li>
      </ul>
    </div>
    <div class="margin-top-20">
      <h2>企业数据库</h2>
      <ul>
        <li @click="handleUpload(7)">清单数据-上传云文件</li>
        <li @click="handleUpload(8)">清单数据-上传本地文件</li>
        <li @click="handleUpload(9)">清单数据-上传数据文件</li>
        <li @click="handleUpload(10)">组价数据-上传云文件</li>
        <li @click="handleUpload(11)">组价数据-上传本地文件</li>
        <li @click="handleUpload(12)">组价数据-上传数据文件</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'test',
  methods: {
    handleUpload (uploadType) {
      switch (uploadType) {
        case 1:
          this.handMessage({
            data: {
              model: 2,
              data: {
                emitName: 'beforeUploadCloudFile',
                uploadParams: [
                  [
                    {
                      'fileId': '23ecbb9562774e2c95708535434f6b3a',
                      'name': 'P6新疆-投标项目.GBQ6',
                      'suffix': 'GBQ6',
                      'folder': false,
                      'length': 717803,
                      'fileType': '1',
                      'path': '/P6新疆-投标项目.GBQ6',
                      'parentPath': '/',
                      'parentId': 'e011878cedff4a18aa422902227af872',
                      'thumbnailUrl': null,
                      'md5': '8d4d71cb85a9f08e2a8314e70e3beaa0',
                      'originalCreatorName': 'ker01@003',
                      'createTime': '2021-06-18',
                      'modifyTime': '2021-06-29',
                      'modifierName': 'ker01@003',
                      'fileProperties': {
                        'region': '新疆',
                        'projectType': 2400,
                        'projectCategory': null,
                        'structureCategory': null,
                        'professionCategory': null,
                        'listRule': null,
                        'quotaRule': null,
                        'isEncrypt': '0'
                      },
                      'permission': true,
                      'extraInfo': 2,
                      'extraInfoStr': '预算',
                      'icons': 'GBQ6',
                      'checked': true
                    },
                    {
                      'fileId': '52bfcdedefe44ffda30bda638bd6633d',
                      'name': '污染雨水处理池.GBQ6',
                      'suffix': 'GBQ6',
                      'folder': false,
                      'length': 1654005,
                      'fileType': '1',
                      'path': '/污染雨水处理池.GBQ6',
                      'parentPath': '/',
                      'parentId': 'e011878cedff4a18aa422902227af872',
                      'thumbnailUrl': null,
                      'md5': 'cde0a7fce0c49b1db7c16bec2cf58a96',
                      'originalCreatorName': 'ker01@003',
                      'createTime': '2021-05-27',
                      'modifyTime': '2021-05-27',
                      'modifierName': 'ker01@003',
                      'fileProperties': {
                        'region': '广东',
                        'projectType': 2500,
                        'projectCategory': null,
                        'structureCategory': null,
                        'professionCategory': null,
                        'listRule': null,
                        'quotaRule': null,
                        'isEncrypt': '0'
                      },
                      'permission': true,
                      'extraInfo': 2,
                      'extraInfoStr': '预算',
                      'icons': 'GBQ6',
                      'checked': true
                    },
                    {
                      'fileId': '2839fd13bc714275a11df953754d6ca8',
                      'name': '广东预算-定额项目18序列（一般计税）.GBQ6',
                      'suffix': 'GBQ6',
                      'folder': false,
                      'length': 1177842,
                      'fileType': '1',
                      'path': '/广东预算-定额项目18序列（一般计税）.GBQ6',
                      'parentPath': '/',
                      'parentId': 'e011878cedff4a18aa422902227af872',
                      'thumbnailUrl': null,
                      'md5': '2bed3a3bf538e7017722a60ceb280679',
                      'originalCreatorName': 'ker01@003',
                      'createTime': '2021-04-22',
                      'modifyTime': '2021-04-22',
                      'modifierName': 'ker01@003',
                      'fileProperties': {
                        'region': '广东',
                        'projectType': 2500,
                        'projectCategory': null,
                        'structureCategory': null,
                        'professionCategory': null,
                        'listRule': null,
                        'quotaRule': null,
                        'isEncrypt': '0'
                      },
                      'permission': true,
                      'extraInfo': 2,
                      'extraInfoStr': '预算',
                      'icons': 'GBQ6',
                      'checked': true
                    },
                    {
                      'fileId': 'd813e54e62794a9387f54e1f81dacc68',
                      'name': '广东-10清单规范-10序列[营业税].GBQ5',
                      'suffix': 'GBQ5',
                      'folder': false,
                      'length': 858653,
                      'fileType': '1',
                      'path': '/广东-10清单规范-10序列[营业税].GBQ5',
                      'parentPath': '/',
                      'parentId': 'e011878cedff4a18aa422902227af872',
                      'thumbnailUrl': null,
                      'md5': 'a803117c32fa75b0c3b18bc095358123',
                      'originalCreatorName': 'ker01@003',
                      'createTime': '2021-03-15',
                      'modifyTime': '2021-03-15',
                      'modifierName': 'ker01@003',
                      'fileProperties': {
                        'region': '广东',
                        'projectType': 2300,
                        'projectCategory': null,
                        'structureCategory': null,
                        'professionCategory': null,
                        'listRule': null,
                        'quotaRule': null,
                        'isEncrypt': '0'
                      },
                      'permission': true,
                      'extraInfo': 2,
                      'extraInfoStr': '预算',
                      'icons': 'GBQ5',
                      'checked': true
                    },
                    {
                      'fileId': '9f1ceafe07324db299f1789837fa694e',
                      'name': '清单%#测试.GBQ6',
                      'suffix': 'GBQ6',
                      'folder': false,
                      'length': 213235,
                      'fileType': '1',
                      'path': '/清单%#测试.GBQ6',
                      'parentPath': '/',
                      'parentId': 'e011878cedff4a18aa422902227af872',
                      'thumbnailUrl': null,
                      'md5': 'f0cb6bbfe3cfae04ceb7885bf648c239',
                      'originalCreatorName': 'ker01@003',
                      'createTime': '2021-02-03',
                      'modifyTime': '2021-03-15',
                      'modifierName': 'ker01@003',
                      'fileProperties': {
                        'region': '河北',
                        'projectType': 2100,
                        'projectCategory': null,
                        'structureCategory': null,
                        'professionCategory': null,
                        'listRule': null,
                        'quotaRule': null,
                        'isEncrypt': '0'
                      },
                      'permission': true,
                      'extraInfo': 2,
                      'extraInfoStr': '预算',
                      'icons': 'GBQ6',
                      'checked': true
                    }
                  ],
                  {
                    params: {'IsOffline': false, 'ImportType': 3, 'SourceType': 2, 'userType': 3},
                    pathList: '["/P6新疆-投标项目.GBQ6","/污染雨水处理池.GBQ6","/广东预算-定额项目18序列（一般计税）.GBQ6","/广东-10清单规范-10序列[营业税].GBQ5","/清单%#测试.GBQ6"]',
                    uploadType: 4,
                    workspaceId: 'e011878cedff4a18aa422902227af872',
                    spaceType: 1,
                    // 新增参数
                    showConfirm: true,
                    isDataModule: true,
                    moduleName: '数据文件',
                    nowPage: 'inventory',
                    uploadAction: 'data_manage/bill_quantity/upload_cloud_file',
                    uploadResultAction: 'data_manage/upload_result'
                  }
                ],
                callbackParams: {'component': 'inventory'}
              }
            }
          })
          break
        case 2:
          this.handMessage({
            data: {
              model: 2,
              data: {
                emitName: 'openUploader',
                uploadParams: {
                  parameter: {
                    uploadType: 2,
                    params: '{"IsOffline":false,"SourceType":4,"ImportType":1,"userType":3}',
                    spaceType: 1
                  },
                  uploadAction: 'data_manage/bill_quantity/upload_local_file',
                  // 新增参数
                  showConfirm: true,
                  isDataModule: true,
                  moduleName: '数据文件',
                  nowPage: 'inventory',
                  uploadResultAction: 'data_manage/upload_result',
                  suffix: 'GBQ5,GPB5,GPV5,GSC5,GSH5,GBQ6,GPB6,GPV6,GSC6,GSH6',
                  suffixAlertMessage: '不支持此类工程文件导入，支持的范围为：08，13清单，后缀名为GBQ5，GPB5，GPV5，GSC5，GSH5，GBQ6，GPB6，GPV6，GSC6，GSH6的工程'
                },
                callbackParams: {component: 'inventory'}
              }
            }
          })
          break
        case 3:
          this.handMessage({
            data: {
              model: 2,
              data: {
                emitName: 'openUploader',
                uploadParams: {
                  parameter: {
                    uploadType: 3,
                    params: '{"IsOffline":false,"SourceType":3,"ImportType":1,"userType":3}',
                    spaceType: 1
                  },
                  uploadAction: 'data_manage/bill_quantity/upload_platform_file',
                  // 新增参数
                  isDataModule: true,
                  moduleName: '数据文件',
                  nowPage: 'inventory',
                  uploadResultAction: 'data_manage/upload_result'
                },
                callbackParams: {component: 'inventory'}
              }
            }
          })
          break
        case 4:
          this.handMessage({
            data: {
              model: 2,
              data: {
                emitName: 'beforeUploadCloudFile',
                uploadParams: [
                  [
                    {
                      fileId: '52bfcdedefe44ffda30bda638bd6633d',
                      name: '污染雨水处理池.GBQ6',
                      suffix: 'GBQ6',
                      folder: false,
                      length: 1654005,
                      fileType: '1',
                      path: '/污染雨水处理池.GBQ6',
                      parentPath: '/',
                      parentId: 'e011878cedff4a18aa422902227af872',
                      thumbnailUrl: null,
                      md5: 'cde0a7fce0c49b1db7c16bec2cf58a96',
                      originalCreatorName: 'ker01@003',
                      createTime: '2021-05-27',
                      modifyTime: '2021-05-27',
                      modifierName: 'ker01@003',
                      fileProperties: {
                        region: '广东',
                        projectType: 2500,
                        projectCategory: null,
                        structureCategory: null,
                        professionCategory: null,
                        listRule: null,
                        quotaRule: null,
                        isEncrypt: '0',
                        coProjectId: null
                      },
                      permission: true,
                      extraInfo: 2,
                      extraInfoStr: '预算',
                      icons: 'GBQ6',
                      checked: true
                    }
                  ],
                  {
                    params: {
                      IsOffline: false,
                      ImportType: 2,
                      SourceType: 2,
                      userType: 3
                    },
                    pathList: '["/污染雨水处理池.GBQ6"]',
                    uploadType: 7,
                    workspaceId: 'e011878cedff4a18aa422902227af872',
                    spaceType: 1,
                    // 新增参数
                    isDataModule: true,
                    moduleName: '数据文件',
                    nowPage: 'combination',
                    uploadAction: 'data_manage/bill_quantity/upload_cloud_file',
                    uploadResultAction: 'data_manage/upload_result'
                  }
                ],
                callbackParams: {component: 'combination'}
              }
            }
          })
          break
        case 5:
          this.handMessage({
            data: {
              model: 2,
              data: {
                emitName: 'openUploader',
                uploadParams: {
                  parameter: {
                    uploadType: 5,
                    params: '{"IsOffline":false,"SourceType":4,"ImportType":2,"userType":3}',
                    spaceType: 1
                  },
                  uploadAction: 'data_manage/bill_quantity/upload_local_file',
                  // 新增参数
                  isDataModule: true,
                  moduleName: '数据文件',
                  nowPage: 'combination',
                  uploadResultAction: 'data_manage/upload_result',
                  suffix: 'GBQ5,GPB5,GPV5,GSC5,GSH5,GBQ6,GPB6,GPV6,GSC6,GSH6',
                  suffixAlertMessage: '不支持此类工程文件导入，支持的范围为：08，13清单，后缀名为GBQ5，GPB5，GPV5，GSC5，GSH5，GBQ6，GPB6，GPV6，GSC6，GSH6的工程'
                },
                callbackParams: {component: 'combination'}
              }
            }
          })
          break
        case 6:
          this.handMessage({
            data: {
              model: 2,
              data: {
                emitName: 'openUploader',
                uploadParams: {
                  parameter: {
                    uploadType: 6,
                    params: '{"IsOffline":false,"SourceType":3,"ImportType":2,"userType":3}',
                    spaceType: 1
                  },
                  uploadAction: 'data_manage/esti/upload_platform_file',
                  // 新增参数
                  isDataModule: true,
                  moduleName: '数据文件',
                  nowPage: 'combination',
                  uploadResultAction: 'data_manage/upload_result'
                },
                callbackParams: {component: 'combination'}
              }
            }
          })
          break
        case 7:
          this.handMessage({
            data: {
              model: 2,
              data: {
                emitName: 'beforeUploadCloudFile',
                uploadParams: [
                  [
                    {
                      fileId: '3a28b8005fe84986b51a30389f29b7b8',
                      name: '定额-仿清单法(3).GBQ5',
                      suffix: 'GBQ5',
                      folder: false,
                      length: 793572,
                      fileType: '1',
                      path: '/定额-仿清单法(3).GBQ5',
                      parentPath: '/',
                      parentId: '40991782f53b464ca51e59de5047b2f6',
                      thumbnailUrl: null,
                      md5: 'd5be15733f51eb46f9494c1228637fb8',
                      originalCreatorName: 't800',
                      createTime: '2021-03-23',
                      modifyTime: '2021-03-23',
                      modifierName: 't800',
                      fileProperties: {
                        region: '北京',
                        projectType: 2500,
                        projectCategory: null,
                        structureCategory: null,
                        professionCategory: null,
                        listRule: null,
                        quotaRule: null,
                        isEncrypt: '0',
                        coProjectId: null
                      },
                      permission: true,
                      extraInfo: 2,
                      extraInfoStr: '预算',
                      icons: 'GBQ5',
                      checked: true
                    }
                  ],
                  {
                    params: {
                      IsOffline: false,
                      ImportType: 3,
                      SourceType: 2,
                      userType: 3
                    },
                    pathList: '["/定额-仿清单法(3).GBQ5"]',
                    uploadType: 4,
                    workspaceId: '40991782f53b464ca51e59de5047b2f6',
                    spaceType: 2,
                    // 新增参数
                    showConfirm: true,
                    isDataModule: true,
                    moduleName: '数据文件',
                    nowPage: 'inventory',
                    uploadAction: 'data_manage/bill_quantity/upload_cloud_file',
                    uploadResultAction: 'data_manage/upload_result'
                  }
                ],
                callbackParams: {component: 'inventory'}
              }
            }
          })
          break
        case 8:
          this.handMessage({
            data: {
              model: 2,
              data: {
                emitName: 'openUploader',
                uploadParams: {
                  parameter: {
                    uploadType: 2,
                    params: '{"IsOffline":false,"SourceType":4,"ImportType":1,"userType":3}',
                    spaceType: 2
                  },
                  uploadAction: 'data_manage/bill_quantity/upload_local_file',
                  // 新增参数
                  showConfirm: true,
                  isDataModule: true,
                  moduleName: '数据文件',
                  nowPage: 'inventory',
                  uploadResultAction: 'data_manage/upload_result',
                  suffix: 'GBQ5,GPB5,GPV5,GSC5,GSH5,GBQ6,GPB6,GPV6,GSC6,GSH6',
                  suffixAlertMessage: '不支持此类工程文件导入，支持的范围为：08，13清单，后缀名为GBQ5，GPB5，GPV5，GSC5，GSH5，GBQ6，GPB6，GPV6，GSC6，GSH6的工程'
                },
                callbackParams: {component: 'inventory'}
              }
            }
          })
          break
        case 9:
          this.handMessage({
            data: {
              model: 2,
              data: {
                emitName: 'openUploader',
                uploadParams: {
                  parameter: {
                    uploadType: 3,
                    params: '{"IsOffline":false,"SourceType":3,"ImportType":1,"userType":3}',
                    spaceType: 2
                  },
                  uploadAction: 'data_manage/bill_quantity/upload_platform_file',
                  // 新增参数
                  isDataModule: true,
                  moduleName: '数据文件',
                  nowPage: 'inventory',
                  uploadResultAction: 'data_manage/upload_result'
                },
                callbackParams: {component: 'inventory'}
              }
            }
          })
          break
        case 10:
          this.handMessage({
            data: {
              model: 2,
              data: {
                emitName: 'beforeUploadCloudFile',
                uploadParams: [
                  [
                    {
                      fileId: '9f07c32c8d5a4452ab91553550fdebaf',
                      name: '湖北概算-清单计价(3).GPB5',
                      suffix: 'GPB5',
                      folder: false,
                      length: 934006,
                      fileType: '1',
                      path: '/湖北概算-清单计价(3).GPB5',
                      parentPath: '/',
                      parentId: '40991782f53b464ca51e59de5047b2f6',
                      thumbnailUrl: null,
                      md5: '609ab742c2b9e1bbc02537151be50691',
                      originalCreatorName: 't800',
                      createTime: '2021-03-23',
                      modifyTime: '2021-03-23',
                      modifierName: 't800',
                      fileProperties: {
                        region: '湖北',
                        projectType: 1100,
                        projectCategory: null,
                        structureCategory: null,
                        professionCategory: null,
                        listRule: null,
                        quotaRule: null,
                        isEncrypt: '0',
                        coProjectId: null
                      },
                      permission: true,
                      extraInfo: 1,
                      extraInfoStr: '概算',
                      icons: 'GPB5',
                      checked: true
                    }
                  ],
                  {
                    params: {
                      IsOffline: false,
                      ImportType: 2,
                      SourceType: 2,
                      userType: 3
                    },
                    pathList: '["/湖北概算-清单计价(3).GPB5"]',
                    uploadType: 7,
                    workspaceId: '40991782f53b464ca51e59de5047b2f6',
                    spaceType: 2,
                    // 新增参数
                    isDataModule: true,
                    moduleName: '数据文件',
                    nowPage: 'combination',
                    uploadAction: 'data_manage/bill_quantity/upload_cloud_file',
                    uploadResultAction: 'data_manage/upload_result'
                  }
                ],
                callbackParams: {component: 'combination'}
              }
            }
          })
          break
        case 11:
          this.handMessage({
            data: {
              model: 2,
              data: {
                emitName: 'openUploader',
                uploadParams: {
                  parameter: {
                    uploadType: 5,
                    params: '{"IsOffline":false,"SourceType":4,"ImportType":2,"userType":3}',
                    spaceType: 2
                  },
                  uploadAction: 'data_manage/bill_quantity/upload_local_file',
                  // 新增参数
                  isDataModule: true,
                  moduleName: '数据文件',
                  nowPage: 'combination',
                  uploadResultAction: 'data_manage/upload_result',
                  suffix: 'GBQ5,GPB5,GPV5,GSC5,GSH5,GBQ6,GPB6,GPV6,GSC6,GSH6',
                  suffixAlertMessage: '不支持此类工程文件导入，支持的范围为：08，13清单，后缀名为GBQ5，GPB5，GPV5，GSC5，GSH5，GBQ6，GPB6，GPV6，GSC6，GSH6的工程'
                },
                callbackParams: {component: 'combination'}
              }
            }
          })
          break
        case 12:
          this.handMessage({
            data: {
              model: 2,
              data: {
                emitName: 'openUploader',
                uploadParams: {
                  parameter: {
                    uploadType: 6,
                    params: '{"IsOffline":false,"SourceType":3,"ImportType":2,"userType":3}',
                    spaceType: 2
                  },
                  uploadAction: 'data_manage/esti/upload_platform_file',
                  // 新增参数
                  isDataModule: true,
                  moduleName: '数据文件',
                  nowPage: 'combination',
                  uploadResultAction: 'data_manage/upload_result'
                },
                callbackParams: {component: 'combination'}
              }
            }
          })
          break
        default:
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .test-upload {
    padding: 24px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    h2 {
      font-size: 24px;
      line-height: 42px;
    }

    ul {
      li {
        height: 34px;
        line-height: 34px;
        cursor: pointer;

        &:hover {
          color: #2079fa;
          background: #f2f2f2;
        }
      }
    }
  }
</style>
